var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from "@angular/core";
import { DataService } from "../../bpg-common/services/data.services";
import { BpgCommonService } from "../../bpg-common/services/bpg-common.service";
import { BpgEventsService } from "../../bpg-events/bpg-events.service";
import { HoshinBudgetService } from "../hoshin-budget.service";
import { DatePipe } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { ConstantValues } from "../../bpg-common/models/bpg-constants";
import { EnvironmentConfiguration } from "src/app/environment/services/environment.configuration";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { hoshinInfoForPrint } from "../download-hoshins.enum";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
var HoshinListingComponent = /** @class */ (function () {
    function HoshinListingComponent(bpgCommonService, bpgEventsService, hoshinBudgetService, data, datePipe, router, route, spinnerService, environment) {
        this.bpgCommonService = bpgCommonService;
        this.bpgEventsService = bpgEventsService;
        this.hoshinBudgetService = hoshinBudgetService;
        this.data = data;
        this.datePipe = datePipe;
        this.router = router;
        this.route = route;
        this.spinnerService = spinnerService;
        this.environment = environment;
        this.onFirstRender = false;
        this.budgetList = [];
        this.chapterId = "";
        this.chapterIds = [];
        this.today = new Date();
        this.currentPage = 0;
        this.limit = ConstantValues.pageLimit;
        this.totalPages = 0;
        this.currentShowingElements = ConstantValues.pageLimit;
        this.timeoutErrorMessage = ConstantValues.timeoutErrorMessage;
        this.isbpgAdmin = false;
        this.isbpgLeadAdmin = false;
        this.isNaacAdmin = false;
        this.hoshins = [];
        this.budgets = [];
        this.pdfList = [];
    }
    HoshinListingComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.environment.envName == "dev" ||
            this.environment.envName == "qa" ||
            this.environment.envName == "prod") {
            if (localStorage.getItem("loginData") == null ||
                localStorage.getItem("loginData") == undefined) {
                this.router.navigate(["/log-out"]);
            }
        }
        if (localStorage.getItem("logOutFlag") == "true") {
            localStorage.clear();
            sessionStorage.clear();
            this.router.navigate(["/log-out"]);
            localStorage.setItem("logOutFlag", "true");
        }
        this.loginData = JSON.parse(localStorage.getItem("loginData"));
        this.userAndRoleIdDTO = {
            userId: this.loginData["userId"],
            roleId: localStorage.getItem("adminId"),
        };
        this.spinnerService.show();
        localStorage.removeItem("searchedEventsCaledarItems");
        this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
        this.adminId = localStorage.getItem("adminId");
        if (localStorage.getItem("isbpgAdmin") == "true") {
            this.isbpgAdmin = true;
        }
        if (localStorage.getItem("isbpgLeadAdmin") === "true") {
            this.isbpgLeadAdmin = true;
        }
        if (localStorage.getItem("isNaacAdmin") == "true") {
            this.isNaacAdmin = true;
        }
        if (this.adminId !== "1" &&
            this.adminId !== "2" &&
            this.adminId !== "3" &&
            this.adminId !== "4" &&
            !this.isbpgAdmin &&
            !this.isbpgLeadAdmin &&
            !this.isNaacAdmin) {
            this.router.navigate(["/site-home"]);
        }
        // if (this.loginDetails == null) {
        //   this.router.navigate(['/login']);
        // }
        sessionStorage.removeItem("MembershipData");
        this.spinnerService.show();
        this.loginData = JSON.parse(localStorage.getItem("loginData"));
        console.log(this.loginData.userId);
        this.userId = this.loginData.userId;
        this.adminId = localStorage.getItem("adminId");
        this.tableShow = false;
        this.data.saveData("default Message");
        this.onFirstRender = true;
        if (this.adminId == 4) {
            this.statusList = [
                { status: "Select All" },
                { status: "APPROVED" },
                { status: "REJECTED" },
            ];
        }
        else {
            this.statusList = [
                { status: "Select All" },
                { status: "APPROVED" },
                { status: "NEW" },
                { status: "REJECTED" },
                { status: "SUBMITTED" },
            ];
        }
        this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(function (data) {
            _this.chapterList = data;
            _this.chapterList.map(function (i) {
                i.siteName = i.siteName + "-" + i.bpgName;
                return i;
            });
            for (var i = 0; i < _this.chapterList.length; i++) {
                if (i == _this.chapterList.length - 1) {
                    _this.chapterId = _this.chapterId + _this.chapterList[i].chapterId;
                }
                else {
                    _this.chapterId =
                        _this.chapterId + _this.chapterList[i].chapterId + ",";
                }
            }
            _this.siteData = {
                filter: {
                    chapterId: _this.chapterId,
                },
                moduleId: 0,
                page: 0,
                presentRole: "",
                searchTerm: "",
                size: 0,
                sortDirection: "DESC",
                sortProperty: "fiscal_year",
                uid: "",
            };
            _this.bpgCommonService.getSiteList(_this.siteData).subscribe(function (data) {
                _this.siteList = data;
                //filter default site from sitelist
                _this.siteList = _this.siteList.filter(function (site) { return site.locationCode !== "DFLT"; });
                _this.siteList.unshift({
                    siteId: 0,
                    siteName: "Select All",
                    bpgName: "",
                });
                for (var i = 0; i < _this.siteList.length; i++) {
                    if (i == 0) {
                        _this.allSiteIds = _this.siteList[i].siteId;
                    }
                    else {
                        _this.allSiteIds = _this.allSiteIds + _this.siteList[i].siteId + ",";
                    }
                }
                _this.siteChange(0);
            });
            _this.chapterList.unshift({
                chapterId: _this.chapterId,
                siteName: "Select All",
                bpgName: "",
            });
            _this.landingData = {
                filter: { chapterId: _this.chapterId },
                moduleId: 0,
                page: 0,
                presentRole: "",
                searchTerm: "",
                size: ConstantValues.pageLimit,
                sortDirection: "DESC",
                sortProperty: null,
                uid: "",
            };
            _this.previousButton = sessionStorage.getItem(_this.buttonType);
            if (_this.previousButton == "BACK" || _this.previousButton == "CANCEL") {
                _this.hoshinData = JSON.parse(localStorage.getItem("searchedBudgetList"));
                //  this.tableShow = true;
                _this.currentPage = _this.hoshinData.page + 1;
                _this.landingData = _this.hoshinData;
                _this.getHoshinList();
                sessionStorage.removeItem(_this.buttonType);
                localStorage.removeItem("searchedBudgetList");
                _this.searchKey = _this.hoshinData.searchTerm;
                if (_this.hoshinData.filter.siteId !== undefined &&
                    _this.hoshinData.filter.siteId.length > 1) {
                    _this.siteId = 0;
                }
                else {
                    _this.siteId = _this.hoshinData.filter.siteId;
                }
                if (_this.hoshinData.filter.bpgId.length > 1) {
                    _this.bpgId = 0;
                }
                else {
                    _this.bpgId = _this.hoshinData.filter.bpgId;
                }
                if (_this.hoshinData.filter.status == null) {
                    _this.status = "Select All";
                }
                else {
                    _this.status = _this.hoshinData.filter.status;
                }
            }
            else {
                _this.spinnerService.show();
                _this.landingData.sortProperty = "fiscal_year";
                _this.getHoshinList();
            }
        }, function (err) {
            _this.spinnerService.hide();
            console.log(JSON.stringify(err.value.message));
            if (err.value.statusText == ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
        // setTimeout(function () {
        //   this.spinnerService.hide();
        // }.bind(this), 1500)
        //document.getElementById("tabledemo").classList.add("table-responsive");
        if (window.innerWidth < 767) {
            this.tableresp = true;
        }
        else {
            this.tableresp = false;
        }
    };
    /** For getting all budget data
     * @class HoshinListingComponent
     * @method getBudgetList
     */
    HoshinListingComponent.prototype.getHoshinList = function () {
        var _this = this;
        this.timeOutError = false;
        this.spinnerService.show();
        this.landingData.filter.adminId = this.adminId;
        this.hoshinBudgetService.getBudgetListing(this.landingData).subscribe(function (data) {
            _this.tableShow = true;
            _this.budgetList = data.content;
            _this.numberOfElements = data.totalElements;
            _this.spinnerService.hide();
            localStorage.setItem("searchedBudgetList", JSON.stringify(_this.landingData));
            if (_this.budgetList.length == 0) {
                _this.tableShow = false;
                _this.noDataFound = true;
            }
            else {
                _this.createPDF();
                _this.tableShow = true;
                _this.noDataFound = false;
                _this.spinnerService.hide();
            }
        }, function (err) {
            _this.spinnerService.hide();
            console.log(JSON.stringify(err.value.message));
            if (err.value.statusText == ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    HoshinListingComponent.prototype.printPdf = function () {
        this.printClicked = true;
        var printContents = document.getElementById("printHoshins").innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
        setTimeout(function () {
            this.printClicked = false;
        }.bind(this), 1000);
    };
    HoshinListingComponent.prototype.createPDF = function () {
        var _this = this;
        this.newList = [];
        this.newList = this.budgetList;
        var _loop_1 = function (i) {
            this_1.hoshinBudgetService
                .getHoshins(this_1.newList[i].budgetId)
                .subscribe(function (data) {
                if (data !== null && data !== undefined) {
                    _this.newList[i] = Object.assign(_this.newList[i], {
                        hoshinDetails: data,
                    });
                }
            });
        };
        var this_1 = this;
        for (var i = 0; i < this.newList.length; i++) {
            _loop_1(i);
        }
    };
    /** For filtering data by current page
     * @class HoshinListingComponent
     * @method pageChanged
     * @params event
     */
    HoshinListingComponent.prototype.pageChanged = function (event) {
        this.landingData.page = event - 1;
        this.currentPage = event;
        if (this.currentPage * this.limit < this.numberOfElements) {
            this.currentShowingElements = this.currentPage * this.limit;
        }
        else if (this.currentPage * this.limit > this.numberOfElements) {
            this.currentShowingElements = this.numberOfElements;
        }
        this.getHoshinList();
    };
    /** For filtering data by chapter basis
     * @class HoshinListingComponent
     * @method chapterSelection
     * @params event
     */
    HoshinListingComponent.prototype.chapterSelection = function (event) {
        var _this = this;
        this.timeOutError = false;
        this.searchKey = "";
        this.chapterId = event.chapterId;
        this.landingData.searchTerm = "";
        this.landingData.filter.chapterId = this.chapterId;
        this.landingData.filter.adminId = this.adminId;
        this.hoshinBudgetService.getBudgetListing(this.landingData).subscribe(function (data) {
            _this.budgetList = data.content;
            _this.numberOfElements = data.totalElements;
            if (_this.budgetList.length == 0) {
                _this.tableShow = false;
                _this.noDataFound = true;
            }
            else {
                _this.tableShow = true;
                _this.noDataFound = false;
                _this.createPDF();
            }
        }, function (err) {
            _this.spinnerService.hide();
            console.log(JSON.stringify(err.value.message));
            if (err.value.statusText == ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    /** For searching the table through keywords
     * @class HoshinListingComponent
     * @method searchBudget
     */
    HoshinListingComponent.prototype.searchBudget = function () {
        var _this = this;
        this.timeOutError = false;
        this.selectedSiteId = this.siteId;
        this.selectedBpgId = this.bpgId;
        this.selectedStatus = this.status;
        this.selectedSiteId = this.selectedSiteId ? this.selectedSiteId : null;
        this.selectedBpgId = this.selectedBpgId ? this.selectedBpgId : null;
        this.searchKey = this.searchKey ? this.searchKey : "";
        if (this.selectedBpgId == 0 || this.selectedBpgId == null) {
            this.selectedBpgId = this.allBpgIds;
        }
        if (this.selectedSiteId == 0 || this.selectedSiteId == null) {
            this.selectedSiteId = this.allSiteIds;
        }
        if (this.selectedStatus == "Select All") {
            this.selectedStatus = null;
        }
        this.landingData = {
            filter: {
                siteId: this.selectedSiteId,
                bpgId: this.selectedBpgId,
                status: this.selectedStatus,
                search: true,
            },
            moduleId: 0,
            page: 0,
            presentRole: "",
            searchTerm: this.searchKey,
            size: ConstantValues.pageLimit,
            sortDirection: "DESC",
            sortProperty: "fiscal_year",
            uid: "1",
        };
        // this.landingData.filter.siteId = this.selectedSiteId;
        // this.landingData.filter.bpgId = this.selectedBpgId;
        // this.landingData.filter.status = this.selectedStatus;
        // this.landingData.filter.search = true;
        // this.landingData.searchTerm = this.searchKey;
        if (this.searchKey != "") {
            this.landingData.filter.chapterId = this.chapterId;
            //this.landingData.sortProperty = "fiscal_year";
        }
        this.landingData.filter.adminId = this.adminId;
        // this.chapterId = (this.chapterId) ? this.chapterId : null;
        // this.searchKey = (this.searchKey) ? this.searchKey : '';
        // this.landingData.page = 0;
        // this.landingData.filter.chapterId = this.chapterId;
        // this.landingData.searchTerm = this.searchKey;
        this.hoshinBudgetService.getBudgetListing(this.landingData).subscribe(function (data) {
            _this.tableShow = true;
            _this.budgetList = data.content;
            localStorage.setItem("searchedBudgetList", JSON.stringify(_this.landingData));
            _this.numberOfElements = data.totalElements;
            _this.currentShowingElements = ConstantValues.pageLimit;
            _this.currentPage = 1;
            if (_this.budgetList.length == 0) {
                _this.tableShow = false;
                _this.noDataFound = true;
            }
            else {
                _this.createPDF();
                _this.tableShow = true;
                _this.noDataFound = false;
            }
        }, function (err) {
            _this.spinnerService.hide();
            console.log(JSON.stringify(err.value.message));
            if (err.value.statusText == ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    /** For sorting the table through columns
     * @class HoshinListingComponent
     * @method sortMe
     */
    HoshinListingComponent.prototype.sortMe = function (sortingby) {
        if (this.landingData.sortDirection == "ASC") {
            this.landingData.sortDirection = "DESC";
            document.getElementById(sortingby + "1").classList.add("fading");
            document.getElementById(sortingby + "2").classList.remove("fading");
        }
        else {
            this.landingData.sortDirection = "ASC";
            document.getElementById(sortingby + "2").classList.add("fading");
            document.getElementById(sortingby + "1").classList.remove("fading");
        }
        this.landingData.sortProperty = sortingby;
        this.getHoshinList();
    };
    /** saving data in service for budget edit
     * @class HoshinListingComponent
     * @method editBudget
     */
    HoshinListingComponent.prototype.editBudget = function (data) {
        //this.data.saveBudget(data);
        data.clone = false;
        sessionStorage.setItem("editBudget", JSON.stringify(data));
    };
    HoshinListingComponent.prototype.viewMoreBudgetDetails = function (data) {
        sessionStorage.setItem("saveBudget", JSON.stringify(data));
    };
    /** For site change from site list
     * @class ExpenseClaimListComponent
     * @method siteChange
     * @returns Promise
     */
    HoshinListingComponent.prototype.siteChange = function (event) {
        var _this = this;
        this.bpgList = [];
        this.selectedBpgId = null;
        this.bpgValue = null;
        if (event != undefined) {
            this.selectedSiteId = event.siteId;
        }
        else {
            this.selectedSiteId = 0;
            this.selectedSiteId = null;
        }
        this.selectedBpgsData = {
            filter: {
                siteId: this.selectedSiteId,
                userId: this.userAndRoleIdDTO.userId,
                adminId: this.userAndRoleIdDTO.roleId,
            },
            moduleId: 0,
            page: 0,
            presentRole: "string",
            searchTerm: "string",
            size: 0,
            sortDirection: "ASC",
            sortProperty: "string",
            uid: "string",
        };
        this.bpgCommonService
            .getMyBPGsList(this.selectedBpgsData)
            .subscribe(function (data) {
            _this.bpgList = data;
            if (_this.bpgList.length > 1) {
                _this.bpgList.unshift({ bpgId: 0, bpgName: "Select All" });
            }
            for (var i = 0; i < _this.bpgList.length; i++) {
                if (i == 0) {
                    _this.allBpgIds = _this.bpgList[i].bpgId;
                }
                else {
                    _this.allBpgIds = _this.allBpgIds + _this.bpgList[i].bpgId + ",";
                }
            }
        });
    };
    /** For bpg change from bpg list
     * @class ExpenseClaimListComponent
     * @method bpgChange
     * @returns Promise
     */
    HoshinListingComponent.prototype.bpgChange = function (event) {
        if (event != undefined) {
            this.selectedBpgId = event.bpgId;
        }
        else {
            this.selectedBpgId = null;
        }
    };
    /** For bpg change from bpg list
     * @class ExpenseClaimListComponent
     * @method changeStatus
     * @returns Promise
     */
    HoshinListingComponent.prototype.changeStatus = function (event) {
        if (event != undefined) {
            this.selectedStatus = event.status;
        }
        else {
            this.selectedStatus = null;
        }
    };
    HoshinListingComponent.prototype.createBudget = function () {
        sessionStorage.removeItem("editBudget");
    };
    HoshinListingComponent.prototype.printHoshins = function () {
        this.method = "printHoshinsConfirmation";
        this.msg1 = " Are you sure you want to print all the Hoshins?";
        this.param = "";
    };
    HoshinListingComponent.prototype.getHoshins = function (budgetId) {
        return this.hoshinBudgetService.getHoshins(budgetId);
    };
    HoshinListingComponent.prototype.printHoshinsConfirmation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _loop_2, this_2, k;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _loop_2 = function (k) {
                            var budgetList, res;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this_2.hoshins = [];
                                        this_2.pdfList = [];
                                        budgetList = {
                                            chapterName: this_2.budgetList[k].chapterName,
                                            fiscalYear: this_2.budgetList[k].fiscalYear,
                                            chapterGoals: this_2.budgetList[k].chapterGoals.replace(/<[^>]*>/g, ""),
                                            affinityGoals: this_2.budgetList[k].affinityGoals.replace(/<[^>]*>/g, ""),
                                            budgetStatus: this_2.budgetList[k].budgetStatus,
                                            requestedBudgetAmount: this_2.budgetList[k].requestedBudgetAmount,
                                            approvedBudgetAmount: this_2.budgetList[k].approvedBudgetAmount,
                                        };
                                        this_2.pdfList.push(budgetList);
                                        return [4 /*yield*/, this_2.getHoshins(this_2.budgetList[k].budgetId)
                                                .toPromise()
                                                .then(function (response) {
                                                _this.hoshins = response;
                                                if (_this.hoshins != null && _this.hoshins != undefined) {
                                                    for (var i = 0; i < _this.hoshins.length; i++) {
                                                        {
                                                            if (_this.hoshins[i].actionPlan.length)
                                                                _this.hoshins[i].actionPlan = _this.hoshins[i].actionPlan.replace(/<[^>]*>/g, "");
                                                            if (_this.hoshins[i].kpi.length)
                                                                _this.hoshins[i].kpi = _this.hoshins[i].kpi.replace(/<[^>]*>/g, "");
                                                            if (_this.hoshins[i].yearEndResults.length)
                                                                _this.hoshins[i].yearEndResults = _this.hoshins[i].yearEndResults.replace(/<[^>]*>/g, "");
                                                            if (_this.hoshins[i].midYearResults.length)
                                                                _this.hoshins[i].midYearResults = _this.hoshins[i].midYearResults.replace(/<[^>]*>/g, "");
                                                            if (_this.hoshins[i].challenges.length)
                                                                _this.hoshins[i].challenges = _this.hoshins[i].challenges.replace(/<[^>]*>/g, "");
                                                            var res_1 = {
                                                                bpgInitiative: _this.hoshins[i].bpgInitiative,
                                                                status: _this.hoshins[i].status,
                                                                businessDrivers: _this.hoshins[i].businessDrivers,
                                                                proposedBudget: _this.hoshins[i].proposedBudget,
                                                                frequency: _this.hoshins[i].frequency,
                                                                lead1Name: _this.hoshins[i].lead1Name,
                                                                lead2Name: _this.hoshins[i].lead2Name,
                                                                actionPlan: _this.hoshins[i].actionPlan,
                                                                kpi: _this.hoshins[i].kpi,
                                                                midYearResults: _this.hoshins[i].midYearResults,
                                                                yearEndResults: _this.hoshins[i].yearEndResults,
                                                                challenges: _this.hoshins[i].challenges,
                                                                evaluation: _this.hoshins[i].evaluation,
                                                                additionalFundingSource: _this.hoshins[i].additionalFundingSource,
                                                                superAdminApprovedBudget: _this.hoshins[i].superAdminApprovedBudget,
                                                                superAdminApprovalComment: _this.hoshins[i].superAdminApprovalComment,
                                                            };
                                                            _this.pdfList.push(res_1);
                                                        }
                                                    }
                                                }
                                                var AmountList = {
                                                    approvedAmount: _this.budgetList[k].approvedBudgetAmount,
                                                    requestedAmount: _this.budgetList[k].requestedBudgetAmount,
                                                };
                                                _this.pdfList.push(AmountList);
                                                var content;
                                                var res;
                                                var documentDefinition = (content = {
                                                    pageOrientation: "portrait",
                                                    content: [
                                                        _this.pdfList.map(function (item, index) {
                                                            if (item.hasOwnProperty("chapterName")) {
                                                                res = [
                                                                    { text: "HOSHIN VIEW\n\n", style: "header" },
                                                                    {
                                                                        text: "Chapter Name   :  " + item.chapterName,
                                                                        style: "leftTextHoshin",
                                                                    },
                                                                    {
                                                                        text: "Fiscal Year            :  " + item.fiscalYear,
                                                                        style: "rightTextFY",
                                                                    },
                                                                    {
                                                                        text: "Affinity Goals     :  " + item.affinityGoals,
                                                                        style: "leftTextHoshin",
                                                                    },
                                                                    {
                                                                        text: "Budget Status       :  " + item.budgetStatus,
                                                                        style: "rightText",
                                                                    },
                                                                    {
                                                                        text: "Chapter Goals   :  " + item.chapterGoals,
                                                                        style: "leftTextHoshin",
                                                                    },
                                                                ];
                                                            }
                                                            if (item.hasOwnProperty("bpgInitiative")) {
                                                                var result = [
                                                                    { text: "\n\nBPG Initiative", style: "header" },
                                                                ];
                                                                var obj2 = {
                                                                    text: "________________________________________________________________________\n\n",
                                                                    style: "horizontalLine",
                                                                };
                                                                result.push(obj2);
                                                                for (var prop in item) {
                                                                    if (item[prop] !== null &&
                                                                        item[prop] !== undefined &&
                                                                        item[prop] !== "") {
                                                                        {
                                                                            var obj = {
                                                                                text: hoshinInfoForPrint[prop],
                                                                                style: "leftTextHeader",
                                                                            };
                                                                            var obj1 = {
                                                                                text: item[prop],
                                                                                style: "leftText",
                                                                            };
                                                                            result.push(obj);
                                                                            result.push(obj1);
                                                                        }
                                                                    }
                                                                }
                                                                res.push(result);
                                                            }
                                                            if (item.hasOwnProperty("approvedAmount")) {
                                                                var approvedAmount = item.approvedAmount
                                                                    ? item.approvedAmount
                                                                    : 0;
                                                                res.push([
                                                                    {
                                                                        text: "Requested Budget Amount: $" +
                                                                            item.requestedAmount +
                                                                            "       Approved Budget Amount : $" +
                                                                            approvedAmount,
                                                                        style: "centerText",
                                                                    },
                                                                ]);
                                                            }
                                                            return res;
                                                        }),
                                                    ],
                                                    styles: {
                                                        header: {
                                                            fontSize: 15,
                                                            bold: true,
                                                            alignment: "left",
                                                        },
                                                        leftTextHoshin: {
                                                            fontSize: 11,
                                                            alignment: "left",
                                                            margin: [0, 0, 0, 5],
                                                        },
                                                        leftText: {
                                                            fontSize: 10,
                                                            alignment: "left",
                                                            margin: [0, 0, 0, 6],
                                                        },
                                                        leftTextHeader: {
                                                            fontSize: 12,
                                                            alignment: "left",
                                                            margin: [0, 2, 0, 2],
                                                            bold: true,
                                                        },
                                                        rightText: {
                                                            fontSize: 11,
                                                            alignment: "right",
                                                            margin: [0, 0, 10, 5],
                                                        },
                                                        rightTextFY: {
                                                            fontSize: 11,
                                                            alignment: "right",
                                                            margin: [0, 0, 43, 5],
                                                        },
                                                        centerText: {
                                                            fontSize: 12,
                                                            bold: true,
                                                            // alignment: "center",
                                                            margin: [90, 3, 5, 0],
                                                        },
                                                        horizontalLine: {
                                                            fontSize: 15,
                                                            bold: true,
                                                            margin: [0, 0, 0, 0],
                                                        },
                                                        defaultStyle: {
                                                            font: "Courier",
                                                        },
                                                    },
                                                });
                                                pdfMake
                                                    .createPdf(documentDefinition)
                                                    .download(_this.budgetList[k].chapterName +
                                                    "-" +
                                                    _this.budgetList[k].fiscalYear +
                                                    ".pdf");
                                            })];
                                    case 1:
                                        res = _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_2 = this;
                        k = 0;
                        _a.label = 1;
                    case 1:
                        if (!(k < this.budgetList.length)) return [3 /*break*/, 4];
                        return [5 /*yield**/, _loop_2(k)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        k++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /** This function calls when user clicks delete icon, asks for confirmation
     * @class HoshinListingComponent
     * @param budgetId
     * @method deleteClick
     */
    HoshinListingComponent.prototype.deleteClick = function (budgetId) {
        this.method = "deleteBudget";
        this.param = budgetId;
        this.msg1 = " Are you sure you want to delete this hoshin? ";
    };
    /** This function calls when user clicks clone icon, asks for confirmation
     * @class HoshinListingComponent
     * @param budgetId
     * @method cloneClick
     */
    HoshinListingComponent.prototype.cloneClick = function (data) {
        this.method = "cloneBudget";
        this.param = data;
        this.msg1 = " Are you sure you want to clone this hoshin? ";
    };
    /** This function soft-deletes budget data in database
     * @class HoshinListingComponent
     * @method deleteBudget
     */
    HoshinListingComponent.prototype.deleteBudget = function (id) {
        var _this = this;
        this.timeOutError = false;
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        this.alertDeleteSuccess = true;
        setTimeout(function () {
            window.location.reload();
            this.alertDeleteSuccess = false;
        }.bind(this), 2500);
        this.hoshinBudgetService.deleteBudget(id).subscribe(function (data) { }, function (err) {
            _this.spinnerService.hide();
            console.log(JSON.stringify(err.value.message));
            if (err.value.statusText == ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    /** This function clone budget data
     * @class HoshinListingComponent
     * @method cloneBudget
     */
    HoshinListingComponent.prototype.cloneBudget = function (data) {
        data.clone = true;
        console.log(data);
        sessionStorage.setItem("editBudget", JSON.stringify(data));
        this.router.navigate(["../create-hoshin"]);
    };
    return HoshinListingComponent;
}());
export { HoshinListingComponent };
